// ignore-string-externalization
import { createAuth } from '@spotify-internal/oauth-silent-authentication';
import { getSpotifyClientId } from '@mrkt/features/env';
import { TokenProviderResult } from './types';

const silentAuth = createAuth({
  clientId: getSpotifyClientId(),
  // this was the default scope in creator-auth-proxy when we switched token providers
  // https://ghe.spotify.net/creator/creator-auth-proxy/blob/f0412cb90bcd067e4bea736383d20b89e0df5680/src/main/java/com/spotify/creator/authproxy/handlers/WebAuthHandler.java#L47-L52
  scopes: [
    'streaming',
    'user-read-email',
    'user-read-private',
    'ugc-image-upload',
  ],
});

const hasSupport =
  typeof window === 'object' &&
  window.location.protocol === 'https:' &&
  /\.spotify\.(net|com)$/.test(window.location.hostname);

export async function getSilentAuthToken(): Promise<TokenProviderResult> {
  // fail when not supported
  if (!hasSupport) {
    throw new Error('failed to get access token');
  }

  try {
    const [token, expiresIn] = await silentAuth.tokenProvider();
    return [token, expiresIn];
  } catch (error) {
    // logged out
    // requires a page refresh after login
    if (error.error === 'login_required') {
      return [undefined, Infinity];
    }

    // rethrow unexpected errors
    throw error;
  }
}
